export const GET_PAYMENT_PROFILES = 'PAYMENT_PROFILES/GET'
export const PAYMENT_PROFILES_SET_LOADING = 'PAYMENT_PROFILES/SET_LOADING'
export const PAYMENT_PROFILES_SET = 'PAYMENT_PROFILES/SET'
export const PAYMENT_PROFILES_SET_FILTER = 'PAYMENT_PROFILES/SET_FILTER'
export const DROP_PAYMENT_PROFILES = 'PAYMENT_PROFILES/DROP'
export const FETCH_INVOICES = 'PAYMENT_PROFILES/FETCH_INVOICES'
export const PAYMENTS_SET_LOADING = 'PAYMENT_PROFILES/PAYMENTS_SET_LOADING'
export const SET_PAYMENTS = 'PAYMENT_PROFILES/PAYMENTS_SET'
export const PAYMENTS_SET_FILTER = 'PAYMENT_PROFILES/PAYMENTS_SET_FILTER'
export const DROP_PAYMENTS = 'PAYMENT_PROFILES/DROP_PAYMENTS'
export const PAYMENT_PROFILE_CREATE = 'PAYMENT_PROFILES/PROFILE_CREATE'
export const GET_ORGANIZATION_SUGGEST = 'PAYMENT_PROFILES/GET_ORGANIZATION_SUGGEST'
export const GET_ORGANIZATION_BANK = 'PAYMENT_PROFILES/GET_ORGANIZATION_BANK'
